<template>
  <zb-modal
    ref="moreModal"
    contentClass="w-800 relative hbt-room-details-modal"
    :showCloseIcon="false"
    class="slide-in-modal"
    @close="$emit('close')"
  >
    <template v-if="roomInfo">
      <div class="px-4">
        <div class="close-btn" @click="$emit('close')">
          <svg width="24" height="24">
            <use fill="black" xlink:href="/img/sprite.svg#ic_close"></use>
          </svg>
        </div>

        <h4 class="my-4 fs-16">{{ roomInfo.name }}</h4>

        <room-image-carousel
          class="wrap-room-image"
          :images="getHbtRoomImages(roomInfo.code)"
        ></room-image-carousel>

        <div>
          <div class="wrap-info my-6 gap-4 p-4">
            <div v-if="roomSize" class="flex items-center pr-2">
              <svg width="24" height="24" class="black flex-none">
                <use xlink:href="/img/sprite.svg#ic_resort" />
              </svg>
              <span class="ml-2 whitespace-no-wrap"> {{ roomSize }} sqm</span>
            </div>
            <div v-if="occupancy" class="flex items-center pr-2">
              <svg width="24" height="24" class="black flex-none">
                <use xlink:href="/img/sprite.svg#ic_people" />
              </svg>
              <span class="ml-2 whitespace-no-wrap">
                up to {{ occupancy }} guests</span
              >
            </div>
            <div v-if="bedType" class="flex items-center pr-2">
              <svg width="24" height="24" class="black flex-none">
                <use xlink:href="/img/sprite.svg#ic_double-bed" />
              </svg>
              <span class="ml-2">{{ bedType }}</span>
            </div>
            <div v-if="childrenNotAllowed" class="flex items-center pr-2">
              <svg width="24" height="24" class="black flex-none">
                <use xlink:href="/img/sprite.svg#ic_adult-only" />
              </svg>
              <span class="ml-2 whitespace-no-wrap">Adults only</span>
            </div>
          </div>
          <div class="mt-6 mb-8">
            {{ roomInfo.description }}
          </div>
          <h2
            v-if="roomInfo && roomInfo.amenities && roomInfo.amenities.length"
            class="fs-20 font-medium mb-6"
          >
            Rooms facilities
          </h2>

          <ul class="grid grid-cols-4 sm:grid-cols-2 md:grid-cols-3">
            <li
              v-for="item in roomInfo.amenities"
              :key="item.code"
              class="flex items-center h-12 gap-2"
            >
              <div class="flex-none">
                <amenity-icon :code="item.code" />
              </div>
              <div class="flex-1">{{ item.name }}</div>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </zb-modal>
</template>

<script>
import { mapGetters } from "vuex";
import AmenityIcon from "./AmenityIcon.vue";
import RoomImageCarousel from "./RoomImageCarousel.vue";

export default {
  components: {
    AmenityIcon,
    RoomImageCarousel,
  },
  props: ["roomCode"],
  computed: {
    ...mapGetters(["getHbtRoom", "getHbtRoomImages"]),
    roomInfo() {
      return this.getHbtRoom(this.roomCode);
    },
    roomSize() {
      return this.roomInfo.room_size_metric;
    },
    occupancy() {
      return this.roomInfo.baseOccupancy;
    },
    bedType() {
      return this.roomInfo.bed_type;
    },
    childrenNotAllowed() {
      if (
        this.roomInfo.childrenAllowed === undefined ||
        this.roomInfo.childrenAllowed === null
      ) {
        return false;
      }

      return !this.roomInfo.childrenAllowed;
    },
  },
  watch: {
    roomInfo(value) {
      if (value) {
        this.$refs.moreModal.show();
      } else {
        this.$refs.moreModal.hide();
      }
    },
  },
};
</script>

<style>
.hbt-room-details-modal {
  padding: 4px !important;
  width: 760px !important;
}
</style>

<style scoped>
.wrap-room-image {
  max-height: 450px;
  object-fit: cover;
  width: 100%;
}

.wrap-room-image ::v-deep img {
  max-height: 450px;
}

.wrap-info {
  background-color: var(--blue-light-1);
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

@media (max-width: 1200px) {
  .wrap-info {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  ::v-deep .VueCarousel-wrapper {
    overflow: hidden !important;
  }

  ::v-deep .VueCarousel-slide {
    max-width: unset !important;
  }
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
  cursor: pointer;
}
</style>
